import React from "react";
import Profilebox from "../Profilebox/Profilebox";
import CustomCalendar from "../Calendar/Calendar";
import Assignments from "../Assignments/Assignments";
import Contacts from "../Contacts/Contacts";

function ProfileBar() {
  return (
    <div className="space-y-3">
      {/* <Profilebox /> */}
      <CustomCalendar />
      <Assignments />
      <Contacts />
    </div>
  );
}

export default ProfileBar;
